import { Button } from '@cbhq/cds-web/buttons';
import { VStack } from '@cbhq/cds-web/layout';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@cbhq/cds-web/overlays';
import { Link, TextBody } from '@cbhq/cds-web/typography';

import { BASE_APPCHAIN_DISCORD_LINK } from ':cloud/utils/links';

type ContactUsModalProps = {
  onClose: () => void;
  isVisible: boolean;
};

export function ContactUsModal({ onClose, isVisible }: ContactUsModalProps) {
  return (
    <Modal visible={isVisible} onRequestClose={onClose} width={450}>
      <ModalHeader title="Get in touch" />
      <ModalBody>
        <VStack spacingVertical={3} gap={3}>
          <TextBody as="p">
            It looks like we don&apos;t have an appchain set up for you yet. Join our{' '}
            <Link href={BASE_APPCHAIN_DISCORD_LINK} target="_blank">
              Base Appchain Discord
            </Link>{' '}
            and let us know if you&apos;d like to set one up.
          </TextBody>
        </VStack>
      </ModalBody>
      <ModalFooter
        primaryAction={
          <Button variant="secondary" onPress={onClose}>
            Got it
          </Button>
        }
      />
    </Modal>
  );
}
